import ResilientTriggeredHookBuilder from "../../../Hooks/ResilientTriggeredHookBuilder";
import useCreateSlotReservation from "../Hooks/useCreateSlotReservation";
import useUpdatePreparedCustomer from "../Hooks/useUpdatePreparedCustomer";

/**
 * Combines the {@link useCreateSlotReservation} and {@link useUpdatePreparedCustomer} hooks into a single resilient process.
 * @remarks Calls {@link useCreateSlotReservation} first. If it fails with a 400 response, call {@link useUpdatePreparedCustomer},
 * and then retry the call to {@link useCreateSlotReservation} and return it.
 */
const useResilientCreateSlotReservation = ResilientTriggeredHookBuilder(
  useCreateSlotReservation,
  useUpdatePreparedCustomer,
  error => error.response?.status === 400
);

export default useResilientCreateSlotReservation;
